import { ITimeSlotDetails } from "@/api/AppApi/services/time-slots/interfaces/api-time-slots-interfces";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Col, Row } from "@/utils/bootstrap";
import { FieldValues, UseFormReturn } from "react-hook-form";
import TimeSlot from "./time-slot/TimeSlot";
import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";

interface Props {
  slots?: ITimeSlotDetails[];
  beside: boolean;
  agreeTerms: boolean;
  form: UseFormReturn<FieldValues, any>;
  productId: number;
  redirectToCheckout: boolean;
  productState?: IuseProductHasAttrsResult
}

const AvailableSlots: React.FC<Props> = ({
  slots,
  beside,
  agreeTerms,
  form,
  productId,
  redirectToCheckout,
  productState,
}) => {
  const t = useTranslation();
  return (
    <div>
      <Row className="m-0 appointment-separator-container">
        <Col className={`p-0 col-auto title}`}>{t.available_slots}</Col>
        <Col className="p-0 separator" />
      </Row>
      <div className="slots">
        {slots?.map((slot) => (
          <TimeSlot
            productState={productState}
            redirectToCheckout={redirectToCheckout}
            agreeTerms={agreeTerms}
            beside={beside}
            key={slot.id}
            slot={slot}
            form={form}
            productId={productId}
          />
        ))}
      </div>
    </div>
  );
};

export default AvailableSlots;
